import { useQuery, useMutation, useQueryClient } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";

export function useDataAdminGrid(baseUrl, primaryKeyField = "id") {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();

  const fetchData = async () => {
    const token = await getAccessTokenSilently();
    const response = await axios.get(baseUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.map((row, index) => {
      const rowIdValue =
        row[primaryKeyField] != null
          ? row[primaryKeyField]
          : `temp_${index + 1}`;
      return { ...row, rowId: rowIdValue };
    });
  };

  const { data = [], isLoading, error } = useQuery([baseUrl], fetchData);

  const saveMutation = useMutation(
    async (payload) => {
      const token = await getAccessTokenSilently();
      const response = await axios.put(baseUrl, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([baseUrl]);
      },
    }
  );

  const deleteMutation = useMutation(
    async (pkValue) => {
      const token = await getAccessTokenSilently();
      await axios.delete(`${baseUrl}/${pkValue}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return pkValue;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([baseUrl]);
      },
    }
  );

  return { rows: data, isLoading, error, saveMutation, deleteMutation };
}
